module.exports = __webpack_public_path__ + "img/noIndividual.c846bea4.svg";